
(function () {
    angular.module('tmx-app').controller('requestsEditCtrl', ['tmxUtility', 'resolvedData', '$state', 'TMX_FINANCE_CONSTANTS', 'tmxResource', 'ToastService', 
        function RequestsEditCtrl( tmxUtility, resolvedData, $state, TMX_FINANCE_CONSTANTS, tmxResource, ToastService) {
            var requestsVM = this;
            requestsVM.vm = {};
            requestsVM.submitRequestData = submitRequestData;
            requestsVM.RequestDetailController = function () { };

            var requestStatuses = TMX_FINANCE_CONSTANTS.REQUEST_STATUSES;
            var entityStatuses = TMX_FINANCE_CONSTANTS.ENTITY_STATUSES;
            var requestTypes = TMX_FINANCE_CONSTANTS.REQUEST_TYPES;
            requestsVM.requestTypes = angular.copy(requestTypes);
            requestsVM.EntityStatusLkp = Object.keys(entityStatuses).map(function (key) { return entityStatuses[key] });
            requestsVM.RequestStatusLkp = Object.keys(requestStatuses).map(function (key) { return requestStatuses[key] });
            requestsVM.RequestTypeLkp = Object.keys(requestTypes).map(function (key) { return requestTypes[key] });


            (function initializeForm() {
                initializeResolveData();
                requestsVM.disableRequestMasterFields = requestsVM.vm.RequestStatusCode != requestStatuses.New.LookupId ? true : false;
                setChildControllers();
            })();


            function setChildControllers() {
                if (requestsVM.vm.RequestTypeCode == requestTypes.UserRequest.LookupId) {
                    requestsVM.RequestDetailController = UsersEditCtrl;
                    requestsVM.RequestDetailController.$inject = ['$scope', '$timeout', 'lookupService','TMX_FINANCE_CONSTANTS', 'CompanyService', 'LocationService', 'RoleManagementService', 'DeviceService', 'BranchService', 'UsersService','tmxUtility','cacheStore'];
                }
                else if (requestsVM.vm.RequestTypeCode == requestTypes.RoleRequest.LookupId) {
                    requestsVM.RequestDetailController = RoleManagementEditCtrl;
                    requestsVM.RequestDetailController.$inject = ['$scope', '$timeout', 'RoleManagementService', 'tmxUtility'];
                }
                else if (requestsVM.vm.RequestTypeCode == requestTypes.BranchRequest.LookupId) {
                    requestsVM.RequestDetailController = CompanyBranchesEditCtrl;
                    requestsVM.RequestDetailController.$inject = ['$scope', '$timeout', 'BranchService', 'LocationService', 'CompanyService', 'LoanProductService','RoleManagementService','lookupService','TMX_FINANCE_CONSTANTS']
                }

            }

            function initializeResolveData() {
                requestsVM.vm = resolvedData.RequestsData.data;
                requestsVM.vm.RequestId = resolvedData.RequestsData.data.RequestId;
                requestsVM.vm.RequestTypeCode = resolvedData.RequestsData.data.RequestTypeCode;
                requestsVM.vm.EntityStatusCode = resolvedData.RequestsData.data.EntityStatusCode;
                requestsVM.vm.RequestStatusCode = resolvedData.RequestsData.data.RequestStatusCode;
                requestsVM.vm.CreatedDate = resolvedData.RequestsData.data.CreatedDate;
                requestsVM.vm.CreatedBy = resolvedData.RequestsData.data.CreatedBy;
                requestsVM.vm.RequestEntity = JSON.parse(resolvedData.RequestsData.data.EntityJson);
            }

            function submitRequestData() {
                if (tmxUtility.exists(requestsVM.vm.RequestStatusCode) && requestsVM.vm.RequestStatusCode != requestStatuses.New.LookupId) {
                    requestsVM.vm.EntityJson = null; // Removing entity JSON from submit request
                    tmxResource("Request").getByAction("SubmitRequest", false, 'post', requestsVM.vm).then(function () {
                        $state.go("^");
                    });
                }
                else {
                    ToastService.showCustomToast("error", "Please perform an action to continue submission.");
                }

            }


        //#region ==== Child Controllers================================

            function UsersEditCtrl($scope, $timeout, lookupService,TMX_FINANCE_CONSTANTS, CompanyService, LocationService, RoleManagementService, DeviceService, BranchService, UsersService,tmxUtility,cacheStore) {
                var userVM = $scope;
                userVM.UsersEditCtrl = {};
                userVM.UsersEditCtrl.vm = {};
                userVM.UsersEditCtrl.vm = $scope.$parent.RequestsEditCtrl.vm.RequestEntity;

                userVM.UsersEditCtrl.readonly = true;
                userVM.UsersEditCtrl.isEdit = true;
                userVM.UsersEditCtrl.StartDateReadonly = true;
                userVM.UsersEditCtrl.EndDateReadonly = true;
                userVM.UsersEditCtrl.loadFromRequestScreen = true;
                userVM.UsersEditCtrl.showAmountLimits = true;

                var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;


                const promises = [
                    lookupService.getLookupByType(lkupType.ID_TYPE),
                    CompanyService.lov(),
                    LocationService.getByAction('Active', true),
                    RoleManagementService.getByAction("Activelov", true),
                    lookupService.getLookupByType(lkupType.DESIGNATION),
                    DeviceService.GetActiveUnassignedDeviceLov(),
                    BranchService.CompanyBranchLov(userVM.UsersEditCtrl.vm.CompanyId),
                    lookupService.getUserTypes(),
                    UsersService.getUserByBranchId((userVM.UsersEditCtrl.vm.TmxCompanyBranchUsersMapping && userVM.UsersEditCtrl.vm.TmxCompanyBranchUsersMapping[0]) ? userVM.UsersEditCtrl.vm.TmxCompanyBranchUsersMapping[0].CompanyBranchId : 0)

                ];
                Promise.all(promises).then(response => {
                    userVM.UsersEditCtrl.IdentifierLkp = response[0];
                    userVM.UsersEditCtrl.Companies = response[1].data;
                    userVM.UsersEditCtrl.gridData = response[2];
                    userVM.UsersEditCtrl.usersRolesLov = response[3].data;
                    userVM.UsersEditCtrl.designationsLookup = response[4];
                    userVM.UsersEditCtrl.Devices = response[5];
                    userVM.UsersEditCtrl.Branches = response[6].data;
                    userVM.UsersEditCtrl.lookup = {};
                    userVM.UsersEditCtrl.lookup.type = setLookupIdInHiddenValue(response[7]);
                    //userVM.UsersEditCtrl.reportingUser = decorateSelectForReportingUser(response[8].data);
                    InitializePage();
                    $timeout(function () { userVM.UsersEditCtrl.showUserTemplate = true; });

                }
                );
                function InitializePage(){
                    associateBranchLoanLimits();
                    setTenantWiseConfigurations();
                    getReportingBoss();
                }

                function setTenantWiseConfigurations(){
                    var configurations = cacheStore.get("Configurations");
                    var INTEGRATION_TENANT = tmxUtility.getConfigurationValue(configurations, 'INTEGRATION_TENANT').toLowerCase();
                    if (INTEGRATION_TENANT == TMX_FINANCE_CONSTANTS.TENANTS.SAMBA) {
                        userVM.UsersEditCtrl.showEffectiveEndDate = true;
                        userVM.UsersEditCtrl.showAmountLimits = false;
                    }
                }
                function associateBranchLoanLimits() {
                    userVM.UsersEditCtrl.vm.TmxCompanyBranchUsersMapping.forEach(cb => {
                        let branchLimit = userVM.UsersEditCtrl.vm.TmxLoanLimit.find(x => x.CompanyBranchID == cb.CompanyBranchId);
                        cb.BranchLoanLimit = branchLimit || {};
                    });
                }

                function setLookupIdInHiddenValue(arrayOfObj) {
                    arrayOfObj.forEach(
                        function (obj) {
                            obj.HiddenValue = obj.LookupId;
                        }
                    );
                    return arrayOfObj;
                }


                function getReportingBoss() {

                    userVM.UsersEditCtrl.vm.TmxCompanyBranchUsersMapping.forEach(cb=>{
                        let branchid = cb.CompanyBranchId;
                        if (branchid) {
                            UsersService.getUserByBranchId(branchid).then(function (response) {
                                cb.BranchUsers = response.data.map(x => ({ LookupId: x.UserId, VisibleValue: x.UserName }));
                            });
                        }
                    });
                }

            }

            function RoleManagementEditCtrl($scope, $timeout, RoleManagementService, tmxUtility) {

            //#region  Variable and scope Initialization
                var roleVM = $scope;
                roleVM.RoleManagementEditCtrl = {};
                roleVM.RoleManagementEditCtrl.vm = {};
                roleVM.RoleManagementEditCtrl.vm = $scope.$parent.RequestsEditCtrl.vm.RequestEntity;
                roleVM.RoleManagementEditCtrl.readonly = true;
                roleVM.RoleManagementEditCtrl.StartDateReadonly = true;
                roleVM.RoleManagementEditCtrl.EndDateReadonly = true;
                roleVM.RoleManagementEditCtrl.loadFromRequestScreen = true;

                roleVM.RoleManagementEditCtrl.MasterEntities = [];
                roleVM.RoleManagementEditCtrl.MasterPrivileges = [];
                roleVM.RoleManagementEditCtrl.MenuEntities = [];
                roleVM.RoleManagementEditCtrl.MenuPrivileges = [];
                roleVM.RoleManagementEditCtrl.FieldEntities = [];
                roleVM.RoleManagementEditCtrl.FieldPrivileges = [];
                roleVM.RoleManagementEditCtrl.ReportEntities = [];
                roleVM.RoleManagementEditCtrl.ReportPrivileges = [];

                var resolvedData = {};
                var exists = tmxUtility.exists;
                var menuHiddenPrivileges = ["Approve", "Verify"];
                var allowedFieldPrivileges = ["View"];
                roleVM.dataLoading = true;

                const promises = [
                    RoleManagementService.getAllPrivileges(),
                    RoleManagementService.getEntity()
                ];

            //#endregion

            //#region  Main functions called on Initialization

                Promise.all(promises).then(response => {
                    resolvedData.Privileges = response[0];
                    resolvedData.Entities = response[1];
                    resolvedData.Role = roleVM.RoleManagementEditCtrl.vm;
                    InitializePage();
                    $timeout(function () {
                        roleVM.RoleManagementEditCtrl.showTemplate = true;
                        roleVM.dataLoading = false;
                    });
                });

                function InitializePage() {
                    populateVmFromResolve();
                    populateEntities();
                    initializePrevileges();
                    populatePrivileges();
                }

            //#endregion

            //#region  Private methods
                function populateVmFromResolve() {
                    if (angular.isDefined(resolvedData.Entities.data)) {
                        roleVM.RoleManagementEditCtrl.entityCombinedList = resolvedData.Entities.data.Data;
                    }
                    else { roleVM.RoleManagementEditCtrl.entityCombinedList = []; }
                    roleVM.RoleManagementEditCtrl.Privileges = resolvedData.Privileges ? resolvedData.Privileges.data : [];
                    roleVM.RoleManagementEditCtrl.Role = exists(resolvedData.Role, 'data') ? resolvedData.Role.data : resolvedData.Role;
                }

                function populateEntities() {

                    if (!angular.isDefined(roleVM.RoleManagementEditCtrl.entityCombinedList) || roleVM.RoleManagementEditCtrl.entityCombinedList == null || roleVM.RoleManagementEditCtrl.entityCombinedList == []) {
                        roleVM.RoleManagementEditCtrl.MasterEntities = [];
                    }
                    else {
                        roleVM.RoleManagementEditCtrl.MasterEntities = [];
                        roleVM.RoleManagementEditCtrl.MenuEntities = [];
                        for (var e = 0; e < roleVM.RoleManagementEditCtrl.entityCombinedList.length; e++) {
                            var entity = roleVM.RoleManagementEditCtrl.entityCombinedList[e];
                            entity.name = entity.EntityName;
                            entity.entityId = entity.EntityId;
                            entity.isChecked = false;
                            entity.privileges = [];

                            if (entity.EntityTableName && entity.EntityTableName.toLowerCase() == "menu") {
                                entity.entityType = "Menu";
                                roleVM.RoleManagementEditCtrl.MenuEntities.push(entity);
                            }
                            else if (entity.EntityTableName && entity.EntityTableName.toLowerCase() == "field") {
                                entity.entityType = "Field";
                                roleVM.RoleManagementEditCtrl.FieldEntities.push(entity);
                            }
                            else if (entity.EntityTableName && entity.EntityTableName.toLowerCase() == "report") {
                                entity.entityType = "Report";
                                roleVM.RoleManagementEditCtrl.ReportEntities.push(entity);
                            }
                            else {//role management
                                entity.entityType = "MasterData";
                                roleVM.RoleManagementEditCtrl.MasterEntities.push(entity)
                            }
                        }
                    }

                }

                function initializePrevileges() {
                    roleVM.RoleManagementEditCtrl.Privileges.sort(function (a, b) { return parseFloat(a.PrivilegeID) - parseFloat(b.PrivilegeID) });

                    for (var i = 0; i < roleVM.RoleManagementEditCtrl.Privileges.length; i++) {
                        roleVM.RoleManagementEditCtrl.Privileges[i].PrivilegesValue = false;
                        roleVM.RoleManagementEditCtrl.Privileges[i].EntityCount = 0;
                        roleVM.RoleManagementEditCtrl.MasterPrivileges.push(angular.copy(roleVM.RoleManagementEditCtrl.Privileges[i]));
                        if (menuHiddenPrivileges.indexOf(roleVM.RoleManagementEditCtrl.Privileges[i].PrivilegeName) <= -1) {
                            roleVM.RoleManagementEditCtrl.MenuPrivileges.push(angular.copy(roleVM.RoleManagementEditCtrl.Privileges[i]));
                        }
                        if (allowedFieldPrivileges.indexOf(roleVM.RoleManagementEditCtrl.Privileges[i].PrivilegeName) > -1) {
                            roleVM.RoleManagementEditCtrl.FieldPrivileges.push(angular.copy(roleVM.RoleManagementEditCtrl.Privileges[i]));
                            roleVM.RoleManagementEditCtrl.ReportPrivileges.push(angular.copy(roleVM.RoleManagementEditCtrl.Privileges[i]));
                        }
                    }
                    for (let i = 0; i < roleVM.RoleManagementEditCtrl.MasterEntities.length; i++) {
                        roleVM.RoleManagementEditCtrl.MasterEntities[i].privileges = angular.copy(roleVM.RoleManagementEditCtrl.MasterPrivileges);
                    }
                    for (let i = 0; i < roleVM.RoleManagementEditCtrl.MenuEntities.length; i++) {
                        roleVM.RoleManagementEditCtrl.MenuEntities[i].privileges = angular.copy(roleVM.RoleManagementEditCtrl.MenuPrivileges);
                    }
                    for (let i = 0; i < roleVM.RoleManagementEditCtrl.FieldEntities.length; i++) {
                        roleVM.RoleManagementEditCtrl.FieldEntities[i].privileges = angular.copy(roleVM.RoleManagementEditCtrl.FieldPrivileges);
                    }
                    for (let i = 0; i < roleVM.RoleManagementEditCtrl.ReportEntities.length; i++) {
                        roleVM.RoleManagementEditCtrl.ReportEntities[i].privileges = angular.copy(roleVM.RoleManagementEditCtrl.ReportPrivileges);
                    }
                    roleVM.RoleManagementEditCtrl.MasterEntitiesSource = angular.copy(roleVM.RoleManagementEditCtrl.MasterEntities);
                    roleVM.RoleManagementEditCtrl.MenuEntitiesSource = angular.copy(roleVM.RoleManagementEditCtrl.MenuEntities);
                    roleVM.RoleManagementEditCtrl.FieldEntitiesSource = angular.copy(roleVM.RoleManagementEditCtrl.FieldEntities);
                    roleVM.RoleManagementEditCtrl.ReportEntitiesSource = angular.copy(roleVM.RoleManagementEditCtrl.ReportEntities);
                }

                function populatePrivileges() {
                    roleVM.RoleManagementEditCtrl.entityMasterCheckCount = 0;
                    roleVM.RoleManagementEditCtrl.entityTransCheckCount = 0;
                    roleVM.RoleManagementEditCtrl.entityFieldCheckCount = 0;
                    roleVM.RoleManagementEditCtrl.entityReportCheckCount = 0;


                    roleVM.RoleManagementEditCtrl.Selectedprivileges = [];
                    if (angular.isDefined(roleVM.RoleManagementEditCtrl.Role.PrivilegeIdsPerEntity)) {
                        roleVM.RoleManagementEditCtrl.Selectedprivileges = angular.copy(roleVM.RoleManagementEditCtrl.Role.PrivilegeIdsPerEntity);
                    }

                    for (var j = 0; j < roleVM.RoleManagementEditCtrl.Selectedprivileges.length; j++) {
                        var entity = roleVM.RoleManagementEditCtrl.Selectedprivileges[j];

                        for (var m = 0; m < roleVM.RoleManagementEditCtrl.MasterEntities.length; m++) {
                            if (entity.EntityId == roleVM.RoleManagementEditCtrl.MasterEntities[m].entityId) {
                                roleVM.RoleManagementEditCtrl.MasterEntities[m].privileges = angular.copy(populateEntityPrivilegeArray(angular.copy(entity.PrivilegeIds), roleVM.RoleManagementEditCtrl.MasterEntities[m]));

                            }
                        }

                        for (let t = 0; t < roleVM.RoleManagementEditCtrl.MenuEntities.length; t++) {
                            if (entity.EntityId == roleVM.RoleManagementEditCtrl.MenuEntities[t].entityId) {
                                roleVM.RoleManagementEditCtrl.MenuEntities[t].privileges = angular.copy(populateEntityPrivilegeArray(angular.copy(entity.PrivilegeIds), roleVM.RoleManagementEditCtrl.MenuEntities[t]));
                            }
                        }

                        for (let f = 0; f < roleVM.RoleManagementEditCtrl.FieldEntities.length; f++) {
                            if (entity.EntityId == roleVM.RoleManagementEditCtrl.FieldEntities[f].entityId) {
                                roleVM.RoleManagementEditCtrl.FieldEntities[f].privileges = angular.copy(populateEntityPrivilegeArray(angular.copy(entity.PrivilegeIds), roleVM.RoleManagementEditCtrl.FieldEntities[f]));
                            }
                        }
                        for (let f = 0; f < roleVM.RoleManagementEditCtrl.ReportEntities.length; f++) {
                            if (entity.EntityId == roleVM.RoleManagementEditCtrl.ReportEntities[f].entityId) {
                                roleVM.RoleManagementEditCtrl.ReportEntities[f].privileges = angular.copy(populateEntityPrivilegeArray(angular.copy(entity.PrivilegeIds), roleVM.RoleManagementEditCtrl.ReportEntities[f]));
                            }
                        }

                    }
                    isMasterPrivilegeChecked();
                    isTransactionPrivilegeChecked();
                    isFieldPrivilegeChecked();
                    isReportPrivilegeChecked();

                //checking all Entity check
                    if (roleVM.RoleManagementEditCtrl.entityMasterCheckCount == roleVM.RoleManagementEditCtrl.MasterEntities.length) {
                        roleVM.RoleManagementEditCtrl.allEntitiesChecked = true;
                    }
                    if (roleVM.RoleManagementEditCtrl.entityTransCheckCount == roleVM.RoleManagementEditCtrl.MenuEntities.length) {//all transactions checked
                        roleVM.RoleManagementEditCtrl.allTransactionsChecked = true;
                    }
                    if (roleVM.RoleManagementEditCtrl.entityFieldCheckCount == roleVM.RoleManagementEditCtrl.FieldEntities.length) {//all field checked
                        roleVM.RoleManagementEditCtrl.allFieldsChecked = true;
                    }
                    if (roleVM.RoleManagementEditCtrl.entityReportCheckCount == roleVM.RoleManagementEditCtrl.ReportEntities.length) {//all field checked
                        roleVM.RoleManagementEditCtrl.allReportsChecked = true;
                    }
                    roleVM.RoleManagementEditCtrl.MasterEntitiesSource = angular.copy(roleVM.RoleManagementEditCtrl.MasterEntities);
                    roleVM.RoleManagementEditCtrl.MenuEntitiesSource = angular.copy(roleVM.RoleManagementEditCtrl.MenuEntities);
                    roleVM.RoleManagementEditCtrl.FieldEntitiesSource = angular.copy(roleVM.RoleManagementEditCtrl.FieldEntities);
                    roleVM.RoleManagementEditCtrl.ReportEntitiesSource = angular.copy(roleVM.RoleManagementEditCtrl.ReportEntities);

                }

                function populateEntityPrivilegeArray(privilegeArr, entity) {
                    var fullPrivilegeArr = [];

                    if (entity.entityType == "MasterData") {
                        fullPrivilegeArr = angular.copy(roleVM.RoleManagementEditCtrl.MasterPrivileges);
                    }
                    else if (entity.entityType == "Menu") {
                        fullPrivilegeArr = angular.copy(roleVM.RoleManagementEditCtrl.MenuPrivileges);
                    }
                    else if (entity.entityType == "Field") {
                        fullPrivilegeArr = angular.copy(roleVM.RoleManagementEditCtrl.FieldPrivileges);
                    }
                    else if (entity.entityType == "Report") {
                        fullPrivilegeArr = angular.copy(roleVM.RoleManagementEditCtrl.ReportPrivileges);
                    }

                    var countPCheck = 0;


                    for (var i = 0; i < privilegeArr.length; i++) {

                        for (var j = 0; j < fullPrivilegeArr.length; j++) {
                            if (privilegeArr[i] == fullPrivilegeArr[j].PrivilegeID) {

                                fullPrivilegeArr[j].PrivilegesValue = true;
                                countPCheck = countPCheck + 1;

                                if (entity.entityType == "MasterData") {
                                    roleVM.RoleManagementEditCtrl.MasterPrivileges[j].EntityCount = roleVM.RoleManagementEditCtrl.MasterPrivileges[j].EntityCount + 1;
                                }
                                else if (entity.entityType == "Menu") {
                                    roleVM.RoleManagementEditCtrl.MenuPrivileges[j].EntityCount = roleVM.RoleManagementEditCtrl.MenuPrivileges[j].EntityCount + 1;
                                }
                                else if (entity.entityType == "Field") {
                                    roleVM.RoleManagementEditCtrl.FieldPrivileges[j].EntityCount = roleVM.RoleManagementEditCtrl.FieldPrivileges[j].EntityCount + 1;
                                }
                                else if (entity.entityType == "Report") {
                                    roleVM.RoleManagementEditCtrl.ReportPrivileges[j].EntityCount = roleVM.RoleManagementEditCtrl.ReportPrivileges[j].EntityCount + 1;
                                }
                            }

                        }

                    }
                    if (entity.entityType == "MasterData") {
                        if (countPCheck > 0 && countPCheck <= fullPrivilegeArr.length) {//all Master privilege for this entity are checked
                            entity.isChecked = true;
                            roleVM.RoleManagementEditCtrl.entityMasterCheckCount = roleVM.RoleManagementEditCtrl.entityMasterCheckCount + 1;

                        }
                    }
                    else if (entity.entityType == "Menu") {

                        if (countPCheck > 0 && countPCheck <= fullPrivilegeArr.length) {//all 7 privileges checked for this Transaction entity
                            entity.isChecked = true;
                            roleVM.RoleManagementEditCtrl.entityTransCheckCount = roleVM.RoleManagementEditCtrl.entityTransCheckCount + 1;
                        }

                    }
                    else if (entity.entityType == "Field") {

                        if (countPCheck > 0 && countPCheck <= fullPrivilegeArr.length) {//all 7 privileges checked for this Transaction entity
                            entity.isChecked = true;
                            roleVM.RoleManagementEditCtrl.entityFieldCheckCount = roleVM.RoleManagementEditCtrl.entityFieldCheckCount + 1;
                        }
                    }
                    else if (entity.entityType == "Report") {

                        if (countPCheck > 0 && countPCheck <= fullPrivilegeArr.length) {
                            entity.isChecked = true;
                            roleVM.RoleManagementEditCtrl.entityReportCheckCount = roleVM.RoleManagementEditCtrl.entityReportCheckCount + 1;
                        }
                    }


                    return fullPrivilegeArr;
                }

                function isMasterPrivilegeChecked() {


                    for (var mp = 0; mp < roleVM.RoleManagementEditCtrl.MasterPrivileges.length; mp++) {
                        if (roleVM.RoleManagementEditCtrl.MasterPrivileges[mp].EntityCount == roleVM.RoleManagementEditCtrl.MasterEntitiesSource.length) {
                            roleVM.RoleManagementEditCtrl.MasterPrivileges[mp].PrivilegesValue = true;

                        }
                        else {
                            roleVM.RoleManagementEditCtrl.MasterPrivileges[mp].PrivilegesValue = false;
                        }
                    }
                    isAllPrivilegeChecked();

                }
                function isTransactionPrivilegeChecked() {
                    for (var tp = 0; tp < roleVM.RoleManagementEditCtrl.MenuPrivileges.length; tp++) {
                        if (roleVM.RoleManagementEditCtrl.MenuPrivileges[tp].EntityCount == roleVM.RoleManagementEditCtrl.MenuEntitiesSource.length) {
                            roleVM.RoleManagementEditCtrl.MenuPrivileges[tp].PrivilegesValue = true;
                        }
                        else {
                            roleVM.RoleManagementEditCtrl.MenuPrivileges[tp].PrivilegesValue = false;
                        }
                    }
                    isAllPrivilegeChecked();
                }

                function isFieldPrivilegeChecked() {
                    for (var tp = 0; tp < roleVM.RoleManagementEditCtrl.FieldPrivileges.length; tp++) {
                        if (roleVM.RoleManagementEditCtrl.FieldPrivileges[tp].EntityCount == roleVM.RoleManagementEditCtrl.FieldEntitiesSource.length) {
                            roleVM.RoleManagementEditCtrl.FieldPrivileges[tp].PrivilegesValue = true;
                        }
                        else {
                            roleVM.RoleManagementEditCtrl.FieldPrivileges[tp].PrivilegesValue = false;
                        }
                    }
                    isAllPrivilegeChecked();
                }
                function isReportPrivilegeChecked() {
                    for (var tp = 0; tp < roleVM.RoleManagementEditCtrl.ReportPrivileges.length; tp++) {
                        if (roleVM.RoleManagementEditCtrl.ReportPrivileges[tp].EntityCount == roleVM.RoleManagementEditCtrl.ReportEntitiesSource.length) {
                            roleVM.RoleManagementEditCtrl.ReportPrivileges[tp].PrivilegesValue = true;
                        }
                        else {
                            roleVM.RoleManagementEditCtrl.ReportPrivileges[tp].PrivilegesValue = false;
                        }
                    }
                    isAllPrivilegeChecked();
                }
                function isAllPrivilegeChecked() {

                    roleVM.RoleManagementEditCtrl.AllPrivilegesChecked = true;
                    roleVM.RoleManagementEditCtrl.AllTransPrivilegesChecked = true;
                    roleVM.RoleManagementEditCtrl.AllFieldPrivilegesChecked = true;
                    for (let mp = 0; mp < roleVM.RoleManagementEditCtrl.MasterPrivileges.length; mp++) {
                        if (roleVM.RoleManagementEditCtrl.MasterPrivileges[mp].PrivilegesValue == false) {
                            roleVM.RoleManagementEditCtrl.AllPrivilegesChecked = false;
                        }
                    }
                    for (let tp = 0; tp < roleVM.RoleManagementEditCtrl.MenuPrivileges.length; tp++) {
                        if (roleVM.RoleManagementEditCtrl.MenuPrivileges[tp].PrivilegesValue == false) {
                            roleVM.RoleManagementEditCtrl.AllTransPrivilegesChecked = false;
                        }
                    }
                    for (let fp = 0; fp < roleVM.RoleManagementEditCtrl.FieldPrivileges.length; fp++) {
                        if (roleVM.RoleManagementEditCtrl.FieldPrivileges[fp].PrivilegesValue == false) {
                            roleVM.RoleManagementEditCtrl.AllFieldPrivilegesChecked = false;
                        }
                    }
                    for (let fp = 0; fp < roleVM.RoleManagementEditCtrl.ReportPrivileges.length; fp++) {
                        if (roleVM.RoleManagementEditCtrl.ReportPrivileges[fp].PrivilegesValue == false) {
                            roleVM.RoleManagementEditCtrl.AllReportPrivilegesChecked = false;
                        }
                    }
                }

            //#endregion

            }

            function CompanyBranchesEditCtrl($scope, $timeout, BranchService, LocationService, CompanyService, LoanProductService,RoleManagementService,lookupService,TMX_FINANCE_CONSTANTS) {
                var branchVM = $scope;
                var resolvedData = {};
                branchVM.CompanyBranchesEditCtrl = {};
                branchVM.CompanyBranchesEditCtrl.vm = {};
                branchVM.CompanyBranchesEditCtrl.vm = $scope.$parent.RequestsEditCtrl.vm.RequestEntity;
                branchVM.CompanyBranchesEditCtrl.lookup = {};
                branchVM.CompanyBranchesEditCtrl.readonly = true;

                const promises = [
                    CompanyService.lov(),
                    LocationService.all(),
                    LoanProductService.getActiveProducts(),                                        
                    RoleManagementService.getByAction("Activelov",true),
                    lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.COMMAND_APPLICATION_STATUS_MAPPING)
                ];
                Promise.all(promises).then(response => {
                    resolvedData.Companies = response[0];
                    resolvedData.Locations = response[1]; // Locations
                    resolvedData.allActiveProducts = response[2];
                    resolvedData.RoleLov = response[3]; // Roles
                    resolvedData.commandTypeLkp = response[4]; // CommandLookup
                    InitializePage();
                    $timeout(function () { branchVM.CompanyBranchesEditCtrl.showTemplate = true; });

                });

                function InitializePage() {
                    InitLookups();
                }

                function InitLookups() {
                    branchVM.CompanyBranchesEditCtrl.gridData = resolvedData.Locations;
                    branchVM.CompanyBranchesEditCtrl.locations = resolvedData.Locations.data;
                    branchVM.CompanyBranchesEditCtrl.lookup.companies = resolvedData.Companies.data;
                    branchVM.CompanyBranchesEditCtrl.lookup.companies.forEach(function (x) { x.LookupId = x.HiddenValue });
                    branchVM.CompanyBranchesEditCtrl.allActiveProduct = resolvedData.allActiveProducts.map(x=> { return {LoanProductId : x.ProductId, LoanProductName : x.ProductName}});
                    branchVM.CompanyBranchesEditCtrl.lookup.roles = resolvedData.RoleLov.data;
                    branchVM.CompanyBranchesEditCtrl.lookup.CommandTypeLkp = resolvedData.commandTypeLkp;
                    branchVM.CompanyBranchesEditCtrl.lookup.CommandTypeLkp.forEach(function (x) {
                        x.LookupId = x.HiddenValue
                    });
                }
            }

        //#endregion

        }]);
})();


